import { render } from "./z-complete-task-modal.vue?vue&type=template&id=7935f8a9"
import script from "./z-complete-task-modal.vue?vue&type=script&lang=js"
export * from "./z-complete-task-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__